var map = {
	"./icon-01.svg": "22b9",
	"./icon-02.svg": "e2fa",
	"./icon-03.svg": "cdee",
	"./icon-04.svg": "4ee9",
	"./icon-05.svg": "3abd",
	"./icon-06.svg": "1e6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8532";